module.exports = __webpack_public_path__ + "img/ic-top-navi-notification-01.5d542e55.svg";